var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.numberClass},[_vm._v("$ "+_vm._s(_vm.formatted)),(_vm.postfix)?_c('small',[_vm._v("/"+_vm._s(_vm.postfix))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }